
import { mountThemeFeature } from './editor-lifecycle.js';

mountThemeFeature(lifecycle => {
const { IntersectionObserver, ResizeObserver, setTimeout, setInterval, requestAnimationFrame } = lifecycle;
/* ============================================================
   SCIENCE page behaviors: the ledger accordions (single-open per
   ledger, Oura grammar) and the framed video facade (poster →
   privacy-friendly YouTube iframe only on click).
   ============================================================ */
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- ledger accordions ---------- */
document.querySelectorAll('[data-ledger]').forEach(ledger => {
  lifecycle.listen(ledger, 'click', e => {
    const head = e.target.closest('.sci-row-head'); if (!head) return;
    const row = head.closest('.sci-row'), wrap = row.querySelector('.sci-row-wrap');
    const opening = !row.classList.contains('is-open');
    ledger.querySelectorAll('.sci-row.is-open').forEach(o => { if (o !== row) collapse(o); });
    opening ? expand(row, wrap) : collapse(row);
  });
  function expand(row, wrap) {
    row.classList.add('is-open');
    row.querySelector('.sci-row-head').setAttribute('aria-expanded', 'true');
    wrap.hidden = false;
    if (reduced) return;
    const h = wrap.scrollHeight;
    wrap.style.height = '0px';
    requestAnimationFrame(() => { wrap.style.height = h + 'px'; });
    lifecycle.listen(wrap, 'transitionend', () => { wrap.style.height = ''; }, { once: true });
  }
  function collapse(row) {
    const wrap = row.querySelector('.sci-row-wrap');
    row.classList.remove('is-open');
    row.querySelector('.sci-row-head').setAttribute('aria-expanded', 'false');
    if (reduced) { wrap.hidden = true; return; }
    wrap.style.height = wrap.scrollHeight + 'px';
    requestAnimationFrame(() => { wrap.style.height = '0px'; });
    lifecycle.listen(wrap, 'transitionend', () => { wrap.hidden = true; wrap.style.height = ''; }, { once: true });
  }
});

/* ---------- video facade — load the iframe only when asked ---------- */
document.querySelectorAll('[data-video]').forEach(btn => {
  lifecycle.listen(btn, 'click', () => {
    const id = btn.dataset.video;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    frame.title = btn.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    btn.replaceChildren(frame);
    btn.style.cursor = 'default';
  }, { once: true });
});

});
